import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout otherLink={{ to: "/privacy", label: "Privacy Policy" }}>
    <div className="py-32" data-testid="terms-page">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="bg-white p-8 md:p-12 shadow-lg">
          <h1 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-8">
            Terms & Conditions
          </h1>
          
          <p className="text-sm text-gray-600 mb-8">Last Updated: October 23, 2026</p>
          
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p>
              These Terms & Conditions apply to SMS/MMS text messaging and other campaign communications from Orlando Rivera for New York State Senate.
            </p>
            
            <p>
              For information about how Orlando Rivera for New York State Senate collects, uses, and protects information, please review our <Link to="/privacy" className="text-campaignRed hover:underline" data-testid="terms-privacy-link">Privacy Policy</Link>.
            </p>
            
            <h2 className="font-oswald text-2xl font-bold uppercase mt-8 mb-4 text-campaignBlack">
              SMS/MMS Text Messaging Terms
            </h2>
            
            <p>
              By entering your phone number and selecting to opt in, you agree to receive recurring SMS/MMS text messages from Orlando Rivera for New York State Senate, including campaign alerts, donation requests, updates, voter outreach, event invitations, polling questions, get-out-the-vote reminders, election information, and other important campaign information.
            </p>
            
            <p className="font-semibold">
              Message frequency varies. Msg & data rates may apply.
            </p>
            
            <p>
              Orlando Rivera for New York State Senate does not charge for text messaging services, but your mobile carrier's standard messaging, data, and other rates and fees may apply. Please contact your carrier for details about your mobile plan.
            </p>
            
            <p>
              You may opt out at any time by replying <strong>STOP</strong> to any text message. You may also reply <strong>HELP</strong> for help.
            </p>
            
            <p>
              For assistance, reply HELP to any message or contact Orlando Rivera for New York State Senate at: <a href="mailto:info@orlandojrivera.com" data-testid="terms-email-link-1" className="text-campaignRed hover:underline">info@orlandojrivera.com</a>
            </p>
            
            <p>
              Consent to receive SMS/MMS text messages is not a condition of making a donation, volunteering, supporting the campaign, or using this website.
            </p>
            
            <h2 className="font-oswald text-2xl font-bold uppercase mt-8 mb-4 text-campaignBlack">
              Mobile Opt-In Data
            </h2>
            
            <p>
              Orlando Rivera for New York State Senate does not sell, rent, or share mobile opt-in data or SMS consent with third parties for their own marketing purposes. Mobile phone numbers and SMS consent information may be shared with service providers only as necessary to operate campaign communications, comply with law, or support campaign operations.
            </p>
            
            <p>
              Carriers are not liable for delayed or undelivered messages.
            </p>
            
            <p>
              By participating in the Orlando Rivera for New York State Senate SMS/MMS messaging program, you agree to these Terms & Conditions and the Privacy Policy.
            </p>
            
            <p className="text-sm text-gray-600 mt-12 pt-8 border-t border-gray-200">
              Paid for by Orlando for Senate.
            </p>
          </div>
        </div>
      </div>
    </div>
    </LegalLayout>
  );
}

